import './libs/in18'
import { ConfigProvider, Modal, notification } from 'antd'
import enUS from 'antd/lib/locale/en_US'
import zhCN from 'antd/lib/locale/zh_CN'
import { Suspense, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { BrowserRouter } from 'react-router-dom'
import * as HomeApi from '@/api/home'
import AuthRouter from '@/routers/authRouter'
import Router from '@/routers/index'
import * as Api from './api/account'
import CustomerService from './components/CustomerService'
import { UserStore } from './global-states'
import { getLanguage, urlSource } from './libs/util'

const App = () => {
  const data = useRef<any>()
  const audioRef = useRef<any>()
  const { t } = useTranslation(['system'])

  useEffect(() => {
    initPage()
    sessionStorage.setItem('activity', '')
    document.addEventListener('visibilitychange', () => {
      document.title = t('system.title')
    })
  }, [])

  const initPage = async () => {
    // checkLangeUage()
    Api.getUserInfo()
    if (!checkPage()) {
      UserStore.checkUserPackage()
    }
    getData()
    setInterval(() => {
      getData()
    }, 10000)
  }

  const destroyAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause()
      audioRef.current.remove()
    }
  }

  const checkPage = () => {
    if (location.href.includes('login') || location.href.includes('mobile')) {
      return true
    }
    return false
  }

  const getData = async () => {
    if (checkPage()) return
    const result = await HomeApi.getCreations({
      page: 0,
      size: window.innerWidth < 1800 ? 20 : 30,
      di: localStorage.getItem('di')
    })

    UserStore.systemReady = true

    UserStore.creationList = result?.list || []
    if (data.current?.length) {
      const creatingIds = data.current.filter((d: any) => d.status === 1 || d.status === 4).map((d: any) => d.id)
      if ((result?.list || []).some((l: any) => l.status !== 4 && l.status !== 1 && creatingIds.includes(l.id))) {
        if (document.visibilityState === 'hidden') {
          document.title = t('system.video_created')
        }
        notification.destroy()
        notification.success({
          message: t('system.video_created'),
          description: <div>{t('system.video_to_see')}</div>,
          duration: null
        })

        destroyAudio()
        const audio = new Audio()
        audio.src = urlSource('hiflys/notice.mp3')
        audio.play()
        setTimeout(() => {
          audio.muted = true
        }, 2000)
        audioRef.current = audio
        UserStore.updateUserPackage()
      }
    }
    data.current = result?.list || []
  }

  const checkLangeUage = () => {
    const language = getLanguage()

    if (!navigator.language.toLocaleLowerCase().includes(language) && !localStorage.getItem('set_language')) {
      if (language === 'zh') {
        Modal.confirm({
          title: 'Warning',
          content:
            'It has been detected that your current language is English. Would you like to switch to the English website?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => {
            localStorage.setItem('set_language', '1')
            window.open('https://flyworks.ai/')
          },
          onCancel: () => {
            localStorage.setItem('set_language', '1')
          }
        })
      } else {
        Modal.confirm({
          title: '提示',
          content: '检测到你当前的语言为中文，是否跳转到中文网站?',
          okText: '是',
          cancelText: '否',
          onOk: () => {
            localStorage.setItem('set_language', '1')
            window.open('https://flyworks.ai/')
          },
          onCancel: () => {
            localStorage.setItem('set_language', '1')
          }
        })
      }
    }
  }

  return (
    <>
      <BrowserRouter>
        <ConfigProvider
          locale={getLanguage() === 'zh' ? zhCN : enUS}
          theme={{
            token: {
              colorPrimary: '#6828a8'
            },
            components: {
              Button: {
                colorPrimary: 'linear-gradient(92deg, #690799 -5.93%, #4A09D5 96.98%)'
              },
              Menu: {
                itemSelectedBg: '#E3DCF3',
                itemHeight: 48,
                itemActiveBg: '#E3DCF3'
              }
            }
          }}
        >
          <AuthRouter>
            <Suspense>
              <>
                <Router />
                <CustomerService />
              </>
            </Suspense>
          </AuthRouter>
        </ConfigProvider>
      </BrowserRouter>
    </>
  )
}
export default App
